// Routing Configuration

import Layout from '@/pages/Layout' // src/pages/layout
import Login from '@/pages/Login'

import { createBrowserRouter } from 'react-router-dom'
import { AuthRoute } from '@/components/AuthRoute'
// import Home from '@/pages/Home'
// import Article from '@/pages/Article'
// import Publish from '@/pages/Publish'
import { Suspense, lazy } from 'react'
// import Jobbid from '@/pages/Jobbid'

// 1. lazy function imports the component
const Home = lazy(() => import('@/pages/Home'))
const Article = lazy(() => import('@/pages/Article'))
const Publish = lazy(() => import('@/pages/Publish'))
const Jobbid = lazy(() => import('@/pages/Jobbid'))
const Users = lazy(() => import('@/pages/Users'));
const Dept = lazy(() => import('@/pages/Dept'));
const Team = lazy(() => import('@/pages/Team'));
const Job = lazy(() => import('@/pages/Job'));
const Upload = lazy(() => import('@/pages/Upload'));
const Bid = lazy(() => import('@/pages/Bid'));
const BidReport = lazy(() => import('@/pages/Panorama'));
const Sms = lazy(() => import('@/pages/Sms'))
const BidPositionConfig = lazy(() => import('@/pages/Job/BidPositionConfig'));
const PageLoading = () => (
  <div style={{ 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center', 
    justifyContent: 'center', 
    height: '80vh' 
  }}>
    <div style={{
      width: '30px',
      height: '30px',
      border: '4px solid #f3f3f3',
      borderTop: '4px solid #1890ff',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
      marginBottom: '12px'
    }}></div>
    <p style={{ color: '#1890ff', fontWeight: '700', fontSize: '18px', margin: 0 }}>
      Synchronizing Data...
    </p>
    <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
  </div>
);

// Configuring a Routing Instance

const router = createBrowserRouter([

  {
    path: "/Jobbid",
    element: (
      <AuthRoute>
        <Suspense fallback={<PageLoading />}>
          <Jobbid />
        </Suspense>
      </AuthRoute>
    )
  },
  // 2. Root path redirection (to prevent employees from seeing the layout)
  {
    path: "/",
    element: <AuthRoute> <Layout /></AuthRoute>,
    children: [
      {
        index: true,
        element: <Suspense fallback={<PageLoading />}><Home /></Suspense>
      },
      {
        path: 'article',
        element: <Suspense fallback={<PageLoading />}><Article /></Suspense>
      },
      {
        path: 'publish',
        element: <Suspense fallback={<PageLoading />}><Publish /></Suspense>
      },
      {
        path: 'users', // Add this line for user management
        element: <Suspense fallback={<PageLoading />}><Users /></Suspense>
      },
      {
        path: 'Dept', // Add this line for user management
        element: <Suspense fallback={<PageLoading />}><Dept /></Suspense>
      },
      {
        path: 'Team', // Add this line for user management
        element: <Suspense fallback={<PageLoading />}><Team /></Suspense>
      },
      {
        path: 'Upload', // Add this line for upload management
        element: <Suspense fallback={<PageLoading />}><Upload /></Suspense>
      },
      {
        path: 'Job', // Add this line for Job management
        element: <Suspense fallback={<PageLoading />}><Job /></Suspense>
      },
      {
        path: 'bid-config/:sessionId', 
        element: <Suspense fallback={<PageLoading />}><BidPositionConfig /></Suspense>
      },
      {
        path: 'Bid', // Add this line for Bid management
        element: <Suspense fallback={<PageLoading />}><Bid /></Suspense>
      },
      {
        path: 'Panorama', // Add this line for Bid management
        element: <Suspense fallback={<PageLoading />}><BidReport /></Suspense>
      },
      {
        path: 'Sms', // Add this route to match the menu key '/Sms'
        element: <Suspense fallback={<PageLoading />}><Sms /></Suspense>
      }
      
      // {
      //   path: 'Jobbid',
      //   element: (
      //     <Suspense fallback={'Loading'}>
      //       <Jobbid />
      //     </Suspense>
      //   )
      // }
    ]
  },
  // {
  //   path: 'Jobbid',
  //   element: <Suspense fallback={'Loading'}><Jobbid /></Suspense>
  // },
  {
    path: "/login",
    element: <Login />
  }
])

export default router